import { render, staticRenderFns } from "./selectContact.vue?vue&type=template&id=1b088c60&scoped=true"
import script from "./selectContact.vue?vue&type=script&lang=js"
export * from "./selectContact.vue?vue&type=script&lang=js"
import style0 from "./selectContact.vue?vue&type=style&index=0&id=1b088c60&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b088c60",
  null
  
)

export default component.exports